export default __webpack_public_path__ + "media/zurb/img/development-process/style_guide-ffad7ff32bf0f2c004901d8fd694a6fa.png";